import {
    weedSprayOptions,
    options
} from 'components/SprayMethodDropdown/constants';
import { SprayMethod } from 'services/sprayEvents/types';
import { selectSprayEventTypeIsCrop } from 'services/sprayEventType/selectors';
import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { OwnProps } from './index';

const selectSprayMethod = (_state: AppState, props: OwnProps): SprayMethod =>
    props.sprayMethod;

const selectSprayMethodText = createDeepEqualSelector(
    selectSprayMethod,
    selectSprayEventTypeIsCrop,
    (sprayMethod, isCropSpray) => {
        const sprayMethodOptions = isCropSpray ? options : weedSprayOptions;

        return sprayMethodOptions.find((option) => option.value === sprayMethod)
            ?.text;
    }
);

export { selectSprayMethod, selectSprayMethodText };
